// extracted by mini-css-extract-plugin
export default {"animals_filter":"AnimalsFilter_animals_filter__Ezdr-","spin":"AnimalsFilter_spin__m9MQC"};